module.exports = __webpack_public_path__ + "static/media/home-animation.bfe9ae23.jpg";